import { render, staticRenderFns } from "./ErgGallery.vue?vue&type=template&id=ec861754&"
import script from "./ErgGallery.vue?vue&type=script&lang=ts&"
export * from "./ErgGallery.vue?vue&type=script&lang=ts&"
import style0 from "./ErgGallery.vue?vue&type=style&index=0&id=ec861754&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports